export default __webpack_public_path__ + "9470cfd98b32fd2377822267626ccec5.png";